import { render, staticRenderFns } from "./ViewHolder.vue?vue&type=template&id=da8efd14&scoped=true&"
import script from "./ViewHolder.vue?vue&type=script&lang=ts&"
export * from "./ViewHolder.vue?vue&type=script&lang=ts&"
import style0 from "./ViewHolder.vue?vue&type=style&index=0&id=da8efd14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8efd14",
  null
  
)

export default component.exports